
import { Component, Vue } from 'vue-property-decorator';
import { FactSample, SampleBatch } from '@/modules/analysis/models/analysisRequest';
import { SampleStatusEnum } from '@/modules/analysis/models/sampleStatusEnum';
import * as SampleService from '@/modules/analysis/services/sampleService';
import * as SampleBatchService from '@/modules/analysis/services/sampleBatchService';
import BarcodeReadResultCard from '@/modules/barcode/components/BarcodeReadResultCard.vue';

enum SearchStatus {
  TYPING,
  FOUND,
  NOT_FOUND
}

@Component({
  components: { BarcodeReadResultCard }
})
export default class ReadBarcode extends Vue {
  protected setAsReceived = false;
  protected setAsFinished = false;
  protected displayUpdateFactsError = false;
  protected textContent = '';
  protected readSample: SampleBatch | null = null;
  protected searchStatus = SearchStatus.TYPING;
  private validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  protected mounted(): void {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  protected destroyed(): void {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  private async onBarcodeInput(barcode: string): Promise<void> {
    await this.fetchSample(barcode).then(() => {
      const facts: FactSample[] = [];
      if (this.setAsReceived) {
        facts.push({ status: SampleStatusEnum.RECEIVED });
      }
      if (this.setAsFinished) {
        facts.push({ status: SampleStatusEnum.FINISHED });
      }
      // Auto-update sample facts if set
      if (facts.length > 0 && this.readSample?.samples[0].id) {
        this.displayUpdateFactsError = false;
        const samplesSend: SampleService.SampleBatchStatusRequest = {
          status: [{ id: this.readSample.samples[0].id, facts }]
        };
        SampleService.updateStatus(samplesSend)
          .then(() => {
            setTimeout(() => {
              this.fetchSample(barcode);
            }, 1000);
          })
          .catch(() => (this.displayUpdateFactsError = true));
      }
    });
  }

  private fetchSample(barcode: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.readSample = null;
      SampleBatchService.readBarcode(barcode)
        .then(async (response) => {
          this.readSample = response.data;
          this.searchStatus = SearchStatus.FOUND;
          resolve();
        })
        .catch(() => {
          this.readSample = null;
          this.searchStatus = SearchStatus.NOT_FOUND;
          reject();
        });
    });
  }

  private handleKeyDown(event: KeyboardEvent): void {
    if (this.searchStatus !== SearchStatus.TYPING) {
      this.textContent = '';
      this.searchStatus = SearchStatus.TYPING;
    }
    if (this.validChars.includes(event.key)) {
      this.textContent += event.key;
    } else if (event.key.charCodeAt(0) === 69) {
      // ENTER
      this.onBarcodeInput(this.textContent);
    } else if (event.key.charCodeAt(0) === 66) {
      // BACKSPACE
      this.textContent = this.textContent.slice(0, -1);
    }
  }

  protected get notFound(): boolean {
    return this.searchStatus === SearchStatus.NOT_FOUND;
  }
}
